import { render, staticRenderFns } from "./EditorControls.vue?vue&type=template&id=c23d9e38&scoped=true&"
import script from "./EditorControls.vue?vue&type=script&lang=js&"
export * from "./EditorControls.vue?vue&type=script&lang=js&"
import style0 from "./EditorControls.vue?vue&type=style&index=0&id=c23d9e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23d9e38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23d9e38')) {
      api.createRecord('c23d9e38', component.options)
    } else {
      api.reload('c23d9e38', component.options)
    }
    module.hot.accept("./EditorControls.vue?vue&type=template&id=c23d9e38&scoped=true&", function () {
      api.rerender('c23d9e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/media/EditorControls.vue"
export default component.exports